import { render, staticRenderFns } from "./CommentBody.vue?vue&type=template&id=74bf27dc&scoped=true&"
import script from "./CommentBody.vue?vue&type=script&lang=js&"
export * from "./CommentBody.vue?vue&type=script&lang=js&"
import style0 from "./CommentBody.vue?vue&type=style&index=0&id=74bf27dc&lang=less&scoped=true&"
import style1 from "./CommentBody.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf27dc",
  null
  
)

export default component.exports